
export class ClientInfoProvider
{
    public get ClientId(): string
    {
        let uniqueClientId = window.localStorage.getItem("unique-client-id") || "";

        if (!uniqueClientId)
        {
            uniqueClientId = "W-" + Math.random().toString(16).substring(2, 8).toUpperCase();

            window.localStorage.setItem("unique-client-id", uniqueClientId);
        }

        return uniqueClientId;
    }

    public get ClientInfo(): string
    {
        try
        {
            const info = {
                ua: navigator.userAgent,
                platform: navigator.platform,
                lang: navigator.language,
                tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
                screen: `${screen.width}x${screen.height}x${screen.colorDepth}`,
                viewport: `${window.innerWidth}x${window.innerHeight}@${window.devicePixelRatio}`,
                touch: navigator.maxTouchPoints || 0,
            };

            return JSON.stringify(info);
        }
        catch (ex: any)
        {
            return "(no client info)";
        }
    }
}